<template>
  <div class="webcardloginMain">
    <div class="webcardloginHead" >
      <div class="headleft">&nbsp;&nbsp;请选择卡包</div>
      <div class="headlright"  @click="cardLogout()">切换用户&nbsp;&nbsp;</div>
    </div>

    <div class="webcardLoginList" style="max-height:400px;  overflow-y:auto;  ">
      <ul>
        <li v-for="(item,index) in docslist" :key="item.id"  @click="cardLogin(index)">
          <div class="ruWrap">
            <img src="./../../assets/img/images/imgT.jpg" class="L imgT" />
            <div class="ruTop" style="width:100%">
              <h3>{{item.cardname}}</h3>
              <p>点击使用</p>
            </div>
          </div>
        </li>
      </ul>
      <div class="webbottomheight"></div>
    </div>

    <div class="webbottom">
      <!-- <div class="item2" @click="cardLogin" style="display:none">
        <p>快速进入</p>
      </div> -->
      <div class="item1" @click="cardBind" style="width:100%;">
        <p>绑定新卡</p>
      </div>
    </div>
  </div>
</template>
<script>
  import * as api from "@/api";
  import { mapMutations } from "vuex";
  import JmmToast from '@/components/JmmToast'
  import wx from "weixin-js-sdk";
  export default {
    name: "userWrap",
    data() {
      return {
        token: "fjenpjlnjinhejcmcnkhcefeehlcaidf",
        sign: "",
        docslist: "",
        mobile:"13810319167",
        appid:"wxec7e055bb57fcca7",
        channel: '',        // 判断渠道ID
      };
    },
    created() {
      this.merchantId = this.$route.query.merchantId;
      if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
        localStorage.setItem('cityMerchantId', this.merchantId);
      }
      //this.token = this.$route.query.token;
      //this.sign = this.$route.query.sign;
      this.channel = this.$route.query.channel 
      //判断渠道ID
      if(null == this.channel || undefined == this.channel){
        this.channel = '';
      }
    },
    components: {
      JmmToast,
    },

    mounted() {
      this.getCode();
     // this.getList();
    },
    methods: {
  cardLogout(){
    localStorage.clear();
     window.top.location.href="weblogin.html#/?timeer=66666";
     window.top.location.reload();
     window.location.reload();
  },
  getCode(){ // 非静默授权，第一次有弹框
    
    this.code = ''
    var local = window.location.href; // 获取页面url
    var appid = this.appid; 
    this.code = this.getUrlCode().code // 截取code
    if (this.code == null || this.code === '') { // 如果没有code，则去请求
      console.log("没有code");
      //JmmToast("没有code");
      //继续验证有没有sessionkey
      if(localStorage.getItem("reSESSIONKEY")==null){
        //跳转首页登录
        window.top.location.href="weblogin.html#/?timeer=66666";
        window.top.location.reload();
        window.location.reload();
      }
      else{
        //获取卡列表
        let _reSIGN=localStorage.getItem("reSIGN");
        let _reSESSIONKEY=localStorage.getItem("reSESSIONKEY");
        console.log("reSESSIONKEY:"+_reSESSIONKEY);
        console.log("reSIGN:"+_reSIGN);
        this.sign=_reSIGN;
        this.getList(_reSIGN,_reSESSIONKEY);
      }
      
      

    } else {
      console.log("code:"+this.code);
        // 通过code获取信息 
        // JmmToast(this.code);
        // this.getList(this.code);
        this.getLogin(this.code);
    }
  },


  getUrlCode() { // 截取url中的code方法
  var url = location.search
  this.winUrl = url
  var theRequest = new Object()
  if (url.indexOf("?") != -1) {
      var str = url.substr(1)
      var strs = str.split("&")
      for(var i = 0; i < strs.length; i ++) {
          theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
      }
  }
  return theRequest
  },

  //点击获取登录内容
   async getLogin(o){
      let _this = this;
      try {
       
        let info={
            appId:this.appid,
            wxcode:o
        };
        
        //JmmToast(localStorage.getItem("qrcodecardnumber"));
        localStorage.setItem("reToken",this.token);
       
        const { code, data, message } =  await api.user.getwebLogin(info);
        console.log(code);
        console.log(data);
        if (code == "000000") {
           
           //console.log(data.sign);
           //console.log(data.SESSIONKEY);
           localStorage.setItem("reSESSIONKEY",data.SESSIONKEY);
           localStorage.setItem("reSIGN",data.sign);
           this.$nextTick(() => {
           this.sign=data.sign;
           this.getList(data.sign,data.SESSIONKEY);
           
          
           })
        }
        else {
          console.log(data);
           HyrToast(submsg || msg)
        }
        
        
      } catch (err) {
        //JmmToast(err);
        console.log(err);
      }

  },


      
      // 点击登录
      async getList(sign,sessionkey) {
        
        let _this = this;
        try {
          
          localStorage.setItem("reToken",_this.token == undefined ? testToken : _this.token);
          
           
          let info  = {
            sign:sign,
            cardRights:"50000",
            userid:0,
          }
          
          const { code, data, message } = await api.user.getcardWebLoginList(info);
            
          if (code == "000000") {
            this.docslist = data;
            //console.log(this.docslist.length);
            //console.log(this.docslist);
          } else {
            if(code=="0"){
              //跳转首页登录
              localStorage.clear();
              window.location.reload();
            }
            // HyrToast(submsg || msg)
          }
        } catch (err) {
          console.log(err);
        }
      },
     async cardLogin(index){
        let _this = this;
        try {
        let info =  {
          "cardRights": "50000",	
          "sign": _this.sign,
          "index": index,
          channel: _this.channel,
        }
        const { code, data, message } = await api.user.getwebLoginUpdateKey(info);
          if (code == "000000") {
            window.parent.gourl();
          }
        }
        catch (err) {
          console.log(err);
        }

        
        // var ua = navigator.userAgent.toLowerCase();
        
        // if(ua.match(/MicroMessenger/i)=="micromessenger") {
        //   //JmmToast("微信环境"+1.5)
        //   //微信环境
        //   wx.miniProgram.getEnv(function (res) {
        //     //JmmToast("微信环境"+2)
        //     console.log(JSON.stringify(info));
        //     if (res.miniprogram) {
        //       wx.miniProgram.reLaunch({
        //         url: '/pages/filmList/filmList?info='+JSON.stringify(info)
        //       });
        //     //   wx.miniProgram.navigateBack({
        //     //     delta: 1,
        //     //   });
        //     //   wx.miniProgram.postMessage({
        //     //     data: info,
        //     //   });
        //     // } else {
        //     //   console.log(3);
        //     //   //非小程序环境下逻辑
        //     //   JmmToast("只支持小程序访问")
        //     //   return false;
        //     }
        //   });
        // }else{
        //   console.log(3);
        //   //非小程序环境下逻辑
        //   JmmToast("只支持小程序访问")
        //   return false;
        // }
      },
      cardBind:function(){
        //window.parent.testaa();
        let _this = this;
        let testToken = _this.token == undefined ? "lmojakdhkadocfaccfjocklccdfkhgoj" : _this.token;
        let testSign = _this.sign == undefined ? "dpbijiiiefibmadgopamipinnnpnphof" : _this.sign;
        window.location.href = "/webcardbind.html#/?merchantId=" + this.merchantId + "&channel=" + this.channel + "&token="+testToken+"&sign="+testSign;
        
      },
    },
  };
</script>

<style lang="stylus">
@import '../../assets/css/common.styl';
@import '../../assets/css/icon.css';
@import '../../assets/css/stylesheet.css';

.webcardloginMain {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #fff;
}

.webcardloginHead{
  width:100%;
  height:50px;
  line-height :50px;
  text-align :center;
}

.webcardloginHead .headleft{
  float:left;
  text-align :left;
  width:70%;
  font-size :30px;
  height :50px;
}

.webcardloginHead .headright{
  float :right;
  text-align :right;
  width:30%;
  font-size :30px;
  height :50px;
  cursor :default;
}


.webardLoginList {
  width: calc(100% - 40px);
  margin: 20px auto;

}

.webcardLoginList li {
  width: 100%;
  height: 205px;
  background: url('../../assets/img/images/bgCard.png') no-repeat center center;
  background-size: cover;
  margin: 20px 0;
  color: #fff;
  border-radius: 15px;
}

.webcardLoginList .ruWrap {
  width: calc(100% - 40px);
  margin: 0 auto;
}

.webcardLoginList .ruWrap img {
  width: 100px;
  height: 100px;
}

.webcardLoginList .ruWrap .L {
  float: left;
}

.webcardLoginList .ruWrap .imgT {
  margin: 40px 20px 0 20px;
}

.webcardLoginList .ruWrap .ruTop {
  padding-top: 50px;
}

.webcardLoginList .ruWrap .ruTop h3 {
  font-size: 34px;
}

.webcardLoginList .ruWrap .ruTop p {
  font-size: 28px;
}

.webbottom {
  position: fixed;
  bottom: 0px;
  background-color: #fff;
  width: 100%;
  height: 80px;
  text-align: center;
}

.webbottom .item1 {
  width: 50%;
  background: #ff1734;
  float: left;
}

.webbottom .item1 p {
  margin: 0;
  font-size: 28px;
  color: #fff;
  line-height: 80px;
}

.webbottom .item2 {
  width: 50%;
  background: #999999;
  float: left;
}

.webbottom .item2 p {
  margin: 0;
  font-size: 28px;
  color: #fff;
  line-height: 80px;
}

.webbottomheight {
  height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/view/webcardlogin/index.vue